import axios from "axios";
import AuthService from "../auth/auth_service";
import { gerarUrl } from "../../utilities/utils/Pageable";

export default class SolicitationService extends AuthService {
  constructor() {
    super("solicitacao");
  }

  findAllDTO(queryParams) {
    queryParams = gerarUrl(queryParams);

    const url = `${this.api_url}solicitacao?${queryParams}`;

    return axios({
      method: "get",
      url: url,
      withCredentials: true,
    }).then((res) => res.data);
  }

  findByStatus(queryParams) {
    queryParams = gerarUrl(queryParams);
    return axios({
      method: "get",
      url: this.api_url + "solicitacao/consulta?" + queryParams,
      withCredentials: true,
    }).then((res) => res.data);
  }

  registerSolicitation(data) {
    return axios({
      method: "post",
      url: this.api_url + "solicitacao",
      data: data,
      withCredentials: true,
    });
  }

  finish(id, operatorId, diagnose, url) {
    return axios({
      method: "PUT",
      url: `${this.api_url}solicitacao/finalizar/${id}`,
      withCredentials: true,
      data: { url: url, operatorId: operatorId, diagnose: diagnose },
    });
  }

  // finish(id, operatorId, diagnose, file) {
  //   return axios({
  //     method: "PUT",
  //     url: `${this.api_url}solicitacao/finalizar/${id}`,
  //     withCredentials: true,
  //     data: { File: file, operatorId: operatorId, diagnose: diagnose },
  //     headers: {
  //       Authorization: "Bearer " + this.token(),
  //       "Content-Type": "multipart/form-data",
  //     },
  //   });
  // }

  download(id) {
    window.open(`${this.api_url}solicitacao/download/${id}`);
  }

  countStatus(month, year) {
    return this.executePermitAll("GET", `/status/${month}/${year}`);
  }

  contarMelhoresOperadores(month, year) {
    return this.executePermitAll("GET", `/melhores/${month}/${year}`).then(
      (res) => res.data
    );
  }

  findByEmAberto(localId) {
    return this.execute("GET", `/aberto/${localId}`).then((res) => res.data);
  }

  avaliar(codigo, avaliacao) {
    return this.execute("PUT", `/avaliar/${codigo}`, avaliacao);
  }
}
